export default __webpack_public_path__ + "static/media/heart-page.52cf022f.svg";